var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHumanIconBlack(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "xxxhdpi/icon/person/black") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Profile-details",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    fillOpacity: 0.87
  }, /*#__PURE__*/React.createElement("g", {
    id: "Profiles-list---1440px",
    transform: "translate(-139.000000, -119.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "new-profile-drop",
    transform: "translate(88.000000, 95.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "human",
    transform: "translate(51.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/person/black"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/person/person_black",
    transform: "translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,12.5149701 C11.2375311,12.5149701 12.594803,12.694609 14.0718563,13.0538922 C15.7485114,13.473056 17.1057832,14.0319326 18.1437126,14.7305389 C19.3812437,15.5489063 20,16.4670608 20,17.4850299 L20,20 L0,20 L0,17.4850299 C0,16.4670608 0.618756287,15.5489063 1.85628743,14.7305389 C2.89421677,14.0319326 4.25148862,13.473056 5.92814371,13.0538922 C7.40519701,12.694609 8.76246886,12.5149701 10,12.5149701 Z M10,10 C9.10179192,10 8.27345689,9.77545135 7.51497006,9.32634731 C6.75648323,8.87724326 6.15269686,8.27345689 5.70359281,7.51497006 C5.25448877,6.75648323 5.02994012,5.9281482 5.02994012,5.02994012 C5.02994012,4.13173204 5.25448877,3.29341707 5.70359281,2.51497006 C6.15269686,1.73652305 6.75648323,1.12275674 7.51497006,0.673652695 C8.27345689,0.224548653 9.10179192,1.0658141e-13 10,1.0658141e-13 C10.8982081,1.0658141e-13 11.7265431,0.224548653 12.4850299,0.673652695 C13.2435168,1.12275674 13.8473031,1.73652305 14.2964072,2.51497006 C14.7455112,3.29341707 14.9700599,4.13173204 14.9700599,5.02994012 C14.9700599,5.9281482 14.7455112,6.75648323 14.2964072,7.51497006 C13.8473031,8.27345689 13.2435168,8.87724326 12.4850299,9.32634731 C11.7265431,9.77545135 10.8982081,10 10,10 Z",
    id: "icon/person/black",
    fillRule: "nonzero"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumanIconBlack);
export default __webpack_public_path__ + "static/media/human_icon_black.ad85bf2f75bb78e8fa90a82067e835ce.svg";
export { ForwardRef as ReactComponent };